module.exports = __webpack_public_path__ + "static/media/love.cf1e414e.webp";